module.exports = __webpack_public_path__ + "static/media/agripreneurs_img3.8df7249f.webp";